import { pluck, distinctUntilChanged } from 'rxjs/operators';

/**
 * @param {Observable<playback-web-player.Playback>} playbackUpdate$
 * @return {Observable<number>}
 */

const createCurrentTimeStream = playbackUpdate$ =>
    playbackUpdate$
        .pipe(
            pluck('currentTime'),
            distinctUntilChanged()
        );

export default createCurrentTimeStream;
